import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Truck } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gray-100 pt-10 pb-6" data-id="element-14">
      <div className="container mx-auto px-4" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-16">
          <div data-id="element-17">
            <div className="flex items-center space-x-2 mb-4" data-id="element-18">
              <Truck className="h-7 w-7 text-blue-600" data-id="element-19" />
              <span className="text-xl font-bold text-gray-800" data-id="element-20">EstMove</span>
            </div>
            <p className="text-gray-600 mb-4" data-id="element-21">
              Professional moving services across Estonia. We make your move
              simple, fast, and worry-free.
            </p>
            <div className="flex space-x-4" data-id="element-22">
              <a href="#" className="text-gray-500 hover:text-blue-600" data-id="element-23">
                <Facebook className="h-5 w-5" data-id="element-24" />
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-600" data-id="element-25">
                <Instagram className="h-5 w-5" data-id="element-26" />
              </a>
            </div>
          </div>
          <div data-id="element-27">
            <h3 className="text-lg font-semibold mb-4 text-gray-800" data-id="element-28">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-29">
              <li data-id="element-30">
                <Link to="/" className="text-gray-600 hover:text-blue-600" data-id="element-31">
                  Home
                </Link>
              </li>
              <li data-id="element-32">
                <Link to="/order" className="text-gray-600 hover:text-blue-600" data-id="element-33">
                  Book a Move
                </Link>
              </li>
              <li data-id="element-34">
                <Link to="/tracking" className="text-gray-600 hover:text-blue-600" data-id="element-35">
                  Track Order
                </Link>
              </li>
              <li data-id="element-36">
                <a href="#services" className="text-gray-600 hover:text-blue-600" data-id="element-37">
                  Services
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-38">
            <h3 className="text-lg font-semibold mb-4 text-gray-800" data-id="element-39">
              Contact Us
            </h3>
            <div className="space-y-3" data-id="element-40">
              <div className="flex items-start space-x-3" data-id="element-41">
                <MapPin className="h-5 w-5 text-blue-600 mt-0.5" data-id="element-42" />
                <span className="text-gray-600" data-id="element-43">Tallinn, Estonia 10115</span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-44">
                <Phone className="h-5 w-5 text-blue-600" data-id="element-45" />
                <span className="text-gray-600" data-id="element-46">+372 5555 1234</span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-47">
                <Mail className="h-5 w-5 text-blue-600" data-id="element-48" />
                <span className="text-gray-600" data-id="element-49">info@estmove.ee</span>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-8 pt-6" data-id="element-50">
          <p className="text-center text-gray-500 text-sm" data-id="element-51">
            © {new Date().getFullYear()} EstMove. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;